/**
 * @description
 * Objeto statistics_external
 */

export class StatisticsExternal {
    public id: number = null;
    public rol: string;
    public nifinteressat: string;
    public nifrepresentant: string;
    public ip: string;
    public createdAt: Date;
    public dateString:string;

    constructor() {}
  
}